import React, { Component } from "react";
import {
  loading,
  alert,
  NavbarAdmin,
  Pagination,
  Modal,
  Select,
  float,
  format_date,
  GET,
  POST,
  PUT,
  DELETE,
  UPLOAD,
  t,
  can,
} from "../../components/CustomComponent.js";
import {
  USER_TYPES,
  SELECTABLE_USER_TYPES,
  USER_TABS,
  TEAMS,
  tabMeta,
  otherTab,
  isPartnerUser,
  typeMeta,
  teamMeta,
  roleMeta,
  initials,
  avatarTone,
  fmtPhone,
  PICTURE_ACCEPT,
  PICTURE_FOLDER,
  PICTURE_MAX_SIZE,
  PICTURE_SIZE_HINT,
} from "../../components/people_option.js";
import { withRouter } from "../../components/withRouter.js";
import { COIN_ICON, coin } from "../../components/wallet_option.js";
import "../../assets/css/property.css";
import "../../assets/css/people.css";
import "../../assets/css/wallet.css";

/* ============================================================================
 * ตั้งค่า › ผู้ใช้งาน  (/ad/users)
 * รายชื่อผู้ใช้ในระบบ : แท็บ + ค้นหา + ตารางผู้ใช้ + เพิ่ม-แก้ไข-ปิดใช้งาน
 *
 * แบ่งเป็นสองแท็บ (USER_TABS ใน people_option.js) :
 *   ทีมงานภายใน — บัญชีที่สร้าง/แก้/ลบได้จากหน้านี้
 *   พาร์ตเนอร์   — บัญชีที่ระบบออกให้ตอนอนุมัติใบสมัคร หน้านี้ดู/แก้ข้อมูลติดต่อและ
 *                 ตั้งรหัสผ่านใหม่ได้ ส่วนการเปิด-ปิดใช้งานกับการลบเป็นของเมนู
 *                 พาร์ตเนอร์ เพราะผูกกับสถานะใบสมัคร (partner.service)
 *
 * ต่อกับ API แล้ว :
 *   GET    admin/users            (Get — แบ่งหน้าฝั่ง server)
 *   GET    admin/users/next-code  (OpenCreate — ขอรหัสพนักงานถัดไป)
 *   GET    admin/roles            (GetRoles — ตัวเลือกบทบาท)
 *   POST   admin/users            (Save — สร้าง)
 *   PUT    admin/users/:uid       (Save — แก้ไข / ToggleActive)
 *   PUT    admin/users/:uid/password (ResetPassword — ตั้งรหัสผ่านใหม่)
 *   DELETE admin/users/:uid       (Delete)
 * ========================================================================== */

const PAGE_SIZE = 8;

const EMPTY_FILTER = { keyword: "" };

const EMPTY_FORM = {
  picture: "",
  full_name: "",
  nickname: "",
  user_code: "",
  email: "",
  line_id: "",
  phone: "",
  user_type: "",
  role_uid: "",
  team: "",
  sales_target: "",
  is_active: true,
  password: "",
  password_confirm: "",
};

/* ฟอร์มตั้งรหัสผ่านใหม่ (ไอคอนกุญแจ) — ยืนยันด้วยรหัสผ่านเดิมของบัญชีนั้น */
const EMPTY_PASSWORD_FORM = {
  current_password: "",
  password: "",
  password_confirm: "",
};

/* ---------------------------------------------------------------- ตัวช่วย */
const isTh = () => (localStorage.getItem("lang") || "TH") !== "EN";
const locale = () => (isTh() ? "th" : "en");
const num = (value) => Number(value || 0).toLocaleString("en-US");

/* "เข้าใช้ล่าสุด" แบบอ่านง่าย — เกิน 1 เดือนแสดงเป็นวันที่จริง */
const timeAgo = (ms) => {
  if (!ms) return t("time_never");
  const minutes = Math.floor((Date.now() - ms) / 60000);
  if (minutes < 1) return t("time_just_now");
  if (minutes < 60) return `${minutes} ${t("time_minutes_ago")}`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} ${t("time_hours_ago")}`;
  const days = Math.floor(hours / 24);
  if (days < 31) return `${days} ${t("time_days_ago")}`;
  return format_date(ms, "dd mmm yyyy", locale());
};

const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email).trim());

/* ช่องที่ไม่บังคับกรอกและล้างค่าได้ ต้องส่งเป็น "-" ไม่ใช่ "" หรือ null
   เพราะ removeEmptyString (services/api.js) ตัดค่าว่างทิ้งก่อนส่งขึ้น API — ฟิลด์ที่
   ถูกล้างจะหายไปจาก body เลย ฝั่ง API จึงอ่านเป็น "ไม่ได้แก้ฟิลด์นี้" แล้วคงค่าเดิมไว้
   ตัวส่งแปลง "-" กลับเป็น "" ให้เอง และ DTO ฝั่ง API เก็บลงฐานข้อมูลเป็น null */
const clearable = (value) => (String(value ?? "").trim() === "" ? "-" : String(value).trim());

/* บัญชีผู้ดูแลระบบสูงสุด : ลบไม่ได้ และเปลี่ยนประเภทผู้ใช้/บทบาทไม่ได้ (backend กันไว้อีกชั้น) */
const isSuperUser = (item) => item?.user_type === "super_user";

/* แปลงข้อมูลจาก API ให้อยู่ในรูปที่หน้านี้ใช้ :
   role มาเป็นอ็อบเจกต์ { uid, name } แต่ฟอร์มและตารางอ้างด้วย role_uid
   วันที่มาเป็น ISO string แต่ timeAgo / format_date ทำงานกับ timestamp */
const toTime = (value) => (value ? new Date(value).getTime() : null);

const normalizeUser = (item) => ({
  ...item,
  nickname: item.nickname || "",
  phone: item.phone || "",
  picture: item.picture || "",
  line_id: item.line_id || "",
  team: item.team || "",
  // เป้ายอดขายไม่ได้ตั้งไว้จะมาเป็น null — ฟอร์มเป็น controlled input จึงต้องเป็นสตริงว่าง
  sales_target: item.sales_target ?? "",
  role_uid: item.role?.uid || "",
  role_name: item.role?.name || "",
  last_login_at: toTime(item.last_login_at),
  created_at: toTime(item.created_at),
});

class UserManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      roles: [],                    // ตัวเลือกบทบาท (GET admin/roles)

      tab: USER_TABS[0].key,        // แท็บที่เปิดอยู่ : ทีมงานภายใน / พาร์ตเนอร์
      counts: {},                   // จำนวนของแต่ละแท็บ (ตามคำค้นปัจจุบัน) — ใช้แสดงบนป้ายแท็บ
      menu_open: "",                // uid ของแถวที่เปิดเมนู "..." อยู่

      filter: { ...EMPTY_FILTER },  // ตัวกรองในฟอร์ม (ยังไม่กดค้นหา)
      applied: { ...EMPTY_FILTER }, // ตัวกรองที่ใช้กับผลลัพธ์ปัจจุบัน
      sort: "login_desc",           // เรียงตามเข้าใช้ล่าสุดเป็นค่าตั้งต้น
      page: 1,
      data: [],
      count: 0,

      modal_form: false,
      modal_view: false,
      modal_password: false,
      edit_uid: "",                 // ว่าง = โหมดเพิ่มผู้ใช้ใหม่
      edit_item: null,              // ผู้ใช้ที่กำลังแก้ไข (ใช้เช็กว่าเป็นบัญชีที่ล็อกไว้ไหม)
      view_item: null,              // ผู้ใช้ที่กำลังเปิดดูรายละเอียด
      password_item: null,          // ผู้ใช้ที่กำลังตั้งรหัสผ่านใหม่
      password_checked: false,      // ผ่านการตรวจรหัสผ่านเดิมแล้ว = เปิดช่องรหัสผ่านใหม่
      password_error: "",           // ข้อความใต้ช่องรหัสผ่านเดิมเมื่อตรวจไม่ผ่าน
      show_password: false,
      form: { ...EMPTY_FORM },
      password_form: { ...EMPTY_PASSWORD_FORM },
    };
  }

  componentDidMount() {
    loading(false);
    this.GetRoles();
    this.Get(1);
  }

  /* -------------------------------------------------------- ดึงรายชื่อผู้ใช้ */
  /* พารามิเตอร์กรองประเภทของแต่ละแท็บ — ดูเหตุผลที่แท็บทีมงานใช้ exclude ได้ที่
     USER_TABS (people_option.js) */
  tabParams = (tab) => {
    const meta = tabMeta(tab);
    return {
      ...(meta.types ? { user_type: meta.types.join(",") } : {}),
      ...(meta.exclude ? { exclude_user_type: meta.exclude.join(",") } : {}),
    };
  };

  Get = async (page = 1, filter = this.state.filter, sort = this.state.sort, tab = this.state.tab) => {
    const keyword = (filter.keyword || "").trim();
    const search = keyword ? { data_search: keyword } : {};
    const other = otherTab(tab);

    loading(true);
    /* ยิงสองคำขอพร้อมกัน : รายการของแท็บที่เปิดอยู่ + จำนวนของอีกแท็บหนึ่ง
       (page_size 1 เพราะเอาแค่ pagination.count ไม่ได้ใช้ข้อมูลในนั้น)
       ตัวเลขบนป้ายแท็บจึงนับตามคำค้นเดียวกัน คนใช้กดสลับแท็บแล้วเจอผลตรงกับที่ป้ายบอก */
    const [result, otherResult] = await Promise.all([
      GET("admin/users", {
        page,
        page_size: PAGE_SIZE,
        sort,
        ...this.tabParams(tab),
        ...search,
      }),
      GET("admin/users", { page: 1, page_size: 1, ...this.tabParams(other.key), ...search }),
    ]);
    loading(false);

    if (!result?.status) return;

    const rows = (result.data || []).map(normalizeUser);

    // ลบรายการสุดท้ายของหน้า แล้วหน้านั้นว่าง — ถอยไปหน้าก่อนหน้าให้อัตโนมัติ
    if (!rows.length && page > 1) return this.Get(page - 1, filter, sort, tab);

    const count = result.pagination?.count || 0;

    this.setState({
      data: rows,
      count,
      page,
      tab,
      menu_open: "", // แถวเปลี่ยนชุดแล้ว เมนูที่ค้างอยู่จะชี้ไปคนละคน
      applied: { ...filter },
      sort,
      counts: {
        [tab]: count,
        // คำขอนับพังไม่ควรทำให้ป้ายแท็บกระพริบเป็น 0 — คงตัวเลขเดิมไว้
        [other.key]: otherResult?.status ? otherResult.pagination?.count || 0 : this.state.counts[other.key],
      },
    });
  };

  /* สลับแท็บ = เริ่มนับหน้าใหม่ แต่คงคำค้นเดิมไว้ เพราะคนมักค้นชื่อคนแล้วไม่แน่ใจ
     ว่าอยู่แท็บไหน ป้ายแท็บบอกจำนวนที่เจอของอีกแท็บให้อยู่แล้ว */
  switchTab = (tab) => {
    if (tab === this.state.tab) return;
    this.Get(1, this.state.applied, this.state.sort, tab);
  };

  /* ตัวเลือกบทบาทของ dropdown — page: 0 = เอาทั้งหมดไม่แบ่งหน้า */
  GetRoles = async () => {
    const result = await GET("admin/roles", { page: 0 });
    if (result?.status) this.setState({ roles: result.data || [] });
  };

  /* ------------------------------------------------------------ ตัวกรอง */
  setFilter = (patch) => this.setState((prev) => ({ filter: { ...prev.filter, ...patch } }));

  clearFilters = () => this.setState({ filter: { ...EMPTY_FILTER } }, () => this.Get(1, { ...EMPTY_FILTER }));

  /* ------------------------------------------------- เปิดฟอร์ม เพิ่ม / แก้ไข */
  OpenCreate = async () => {
    this.setState({
      modal_form: true,
      modal_view: false,
      edit_uid: "",
      edit_item: null,
      show_password: false,
      form: { ...EMPTY_FORM },
    });

    // ให้ backend ออกเลขรหัสพนักงานให้ เพราะหน้านี้เห็นข้อมูลแค่หน้าเดียว
    const result = await GET("admin/users/next-code");
    if (result?.status) this.setForm({ user_code: result.data?.user_code || "" });
  };

  OpenEdit = (item) => {
    this.setState({
      modal_form: true,
      modal_view: false,
      edit_uid: item.uid,
      edit_item: item,
      show_password: false,
      form: {
        picture: item.picture || "",
        full_name: item.full_name || "",
        nickname: item.nickname || "",
        user_code: item.user_code || "",
        email: item.email || "",
        line_id: item.line_id || "",
        phone: item.phone || "",
        user_type: item.user_type || "",
        role_uid: item.role_uid || "",
        team: item.team || "",
        sales_target: item.sales_target ?? "",
        is_active: !!item.is_active,
        password: "",
        password_confirm: "",
      },
    });
  };

  OpenView = (item) => this.setState({ modal_view: true, view_item: item });

  /* ตั้งรหัสผ่านใหม่ให้ผู้ใช้ — แยกจากฟอร์มแก้ไข เพราะต้องยืนยันด้วยรหัสผ่านเดิม */
  OpenPassword = (item) =>
    this.setState({
      modal_password: true,
      modal_view: false,
      password_item: item,
      show_password: false,
      password_checked: false,
      password_error: "",
      password_form: { ...EMPTY_PASSWORD_FORM },
    });

  setForm = (patch) => this.setState((prev) => ({ form: { ...prev.form, ...patch } }));

  /* ------------------------------------------------------------ รูปโปรไฟล์ */
  /* อัปขึ้น storage ทันทีที่เลือก (ไม่รอกดบันทึก) เพราะฟอร์มนี้เป็นโมดัลที่ปิดแล้ว
     ค่าที่ค้างอยู่หายหมด — เก็บเป็น URL ตั้งแต่ต้นจึงพรีวิวได้ตรงกับที่จะบันทึกจริง */
  PickPicture = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = ""; // เลือกไฟล์เดิมซ้ำได้
    if (!file) return;

    if (!file.type?.startsWith("image/")) return alert("", "warning", t("warning"), t("verify_picture_type"));
    if (file.size > PICTURE_MAX_SIZE) return alert("", "warning", t("warning"), t("verify_picture_size"));

    loading(true);
    const result = await UPLOAD(file, { folder: PICTURE_FOLDER });
    loading(false);

    if (!result?.status || !result.data?.file_path) {
      return alert("", "warning", t("warning"), result?.message || t("upload_failed"));
    }

    this.setForm({ picture: result.data.file_path });
  };

  /* ลบรูปทิ้ง = กลับไปใช้อักษรย่อ ถามยืนยันก่อนเพราะปุ่มอยู่ติดกับปุ่มเปลี่ยนรูป
     และกดพลาดแล้วต้องไปหาไฟล์เดิมมาอัปใหม่

     บันทึก null ลงฐานข้อมูลทันทีเหมือนตอนอัปรูป (PickPicture) ไม่รอกดบันทึก —
     ถ้ารอ ผู้ใช้ที่กดยืนยันลบแล้วปิดโมดัลไปเลยจะเห็นรูปเดิมค้างอยู่ ทั้งที่กล่อง
     ยืนยันบอกว่าลบแล้ว

     ไม่ลบไฟล์บน storage เพราะ URL เดิมอาจถูกอ้างอยู่ที่อื่น (เช่นแคชของหน้าเว็บ
     ฝั่งลูกค้า) — แบบเดียวกับโลโก้ช่องทางในเมนูการตลาด */
  ClearPicture = async () => {
    if (!(await alert("", "warning", t("picture_remove"), t("picture_remove_confirm"), t("confirm"), t("cancel")))) return;

    const { edit_uid } = this.state;

    // โหมดเพิ่มผู้ใช้ใหม่ยังไม่มีแถวในฐานข้อมูลให้แก้ — ล้างค่าในฟอร์มอย่างเดียว
    if (!edit_uid) return this.setForm({ picture: "" });

    loading(true);
    const result = await PUT("admin/users/" + edit_uid, { picture: "-" });
    loading(false);

    if (!result?.status) return;

    // edit_item ต้องสะท้อนค่าที่บันทึกไว้จริงเสมอ เพราะ Save ใช้เทียบว่ารูปเปลี่ยนไหม
    this.setState((prev) => ({
      form: { ...prev.form, picture: "" },
      edit_item: prev.edit_item ? { ...prev.edit_item, picture: "" } : prev.edit_item,
    }));

    await this.Get(this.state.page);
    alert("", "success", t("success"), t("picture_remove_done"));
  };

  setPasswordForm = (patch) =>
    this.setState((prev) => ({ password_form: { ...prev.password_form, ...patch } }));

  /* แก้รหัสผ่านเดิมหลังตรวจผ่านแล้ว = ต้องกดตรวจใหม่ กันกรอกผิดคนแล้วบันทึกทับ */
  setCurrentPassword = (value) =>
    this.setState((prev) => ({
      password_form: { ...prev.password_form, current_password: value },
      password_checked: false,
      password_error: "",
    }));

  /* ตรวจรหัสผ่านเดิมก่อน จึงเปิดช่องรหัสผ่านใหม่ให้กรอก */
  CheckCurrentPassword = async () => {
    const { password_form: form, password_item: item } = this.state;
    if (!item) return;
    if (!form.current_password) return this.setState({ password_error: t("verify_current_password") });

    loading(true);
    const result = await POST("admin/users/" + item.uid + "/password/verify", {
      current_password: form.current_password,
    });
    loading(false);

    if (!result?.status) return;

    if (!result.data?.valid) return this.setState({ password_checked: false, password_error: t("invalid_current_password") });

    this.setState({ password_checked: true, password_error: "" });
  };

  /* -------------------------------------------------------- บันทึกข้อมูล */
  Save = async () => {
    const { form, edit_uid, edit_item } = this.state;
    const email = form.email.trim();
    /* บัญชีพาร์ตเนอร์ไม่มีทีม/เป้ายอดขาย และห้ามเปลี่ยนบทบาท (ดู renderFormModal)
       จึงไม่บังคับกรอกและไม่ส่งฟิลด์พวกนี้ขึ้นไป — ที่นี่แก้ได้แค่ข้อมูลติดต่อ */
    const managed = isPartnerUser(edit_item);

    if (!form.full_name.trim()) return alert("", "warning", t("warning"), t("verify_full_name"));
    if (!form.user_code.trim()) return alert("", "warning", t("warning"), t("verify_user_code"));
    if (!email) return alert("", "warning", t("warning"), t("verify_contact_email"));
    if (!isValidEmail(email)) return alert("", "warning", t("warning"), t("invalid_email_address"));
    if (!form.user_type) return alert("", "warning", t("warning"), t("verify_user_type"));
    if (!form.role_uid) return alert("", "warning", t("warning"), t("verify_role_id"));
    if (!managed && !form.team) return alert("", "warning", t("warning"), t("verify_team"));
    // สร้างใหม่ต้องตั้งรหัสผ่าน / แก้ไขเปลี่ยนรหัสผ่านที่นี่ไม่ได้ ต้องใช้ปุ่มกุญแจ
    if (!edit_uid) {
      if ((form.password || "").length < 8) return alert("", "warning", t("warning"), t("verify_password_length"));
      if (form.password !== form.password_confirm) return alert("", "warning", t("warning"), t("verify_password_match"));
    }

    if (!(await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel")))) return;

    /* รูปโปรไฟล์ส่งไปเฉพาะตอนที่ค่าจะเปลี่ยนจริง :
         ไม่มีรูป      -> "-"   ล้างค่าเดิม (ดูหมายเหตุที่ clearable)
         รูปใหม่       -> URL   อัปโหลดใหม่หรือเปลี่ยนรูปมา
         รูปเดิมไม่เปลี่ยน -> ข้าม ไม่ใส่ใน body เลย
       ที่ต้องข้ามเพราะรูปถูกบันทึกไปตั้งแต่ตอนอัป/ตอนลบแล้ว (PickPicture/ClearPicture)
       ส่งซ้ำมีแต่จะเขียนทับค่าที่อาจถูกแก้จากที่อื่นระหว่างที่โมดัลเปิดค้างอยู่ */
    const picture = form.picture.trim();
    const savedPicture = (edit_item?.picture || "").trim();

    const body = {
      ...(picture ? (picture === savedPicture ? {} : { picture }) : { picture: "-" }),
      full_name: form.full_name.trim(),
      nickname: clearable(form.nickname),
      user_code: form.user_code.trim(),
      email,
      line_id: clearable(form.line_id),
      phone: clearable(form.phone),
      ...(managed
        ? {}
        : {
            user_type: form.user_type,
            role_uid: form.role_uid,
            team: form.team,
            // ปล่อยว่าง = ยังไม่ตั้งเป้า ส่ง "-" ไปล้างค่าเดิม (รายงานจะไม่คิด % ให้)
            sales_target: String(form.sales_target).trim() === "" ? "-" : Number(form.sales_target),
          }),
      ...(isSuperUser(edit_item) || managed ? {} : { is_active: form.is_active }),
      ...(edit_uid ? {} : { password: form.password }), // ตั้งรหัสผ่านได้เฉพาะตอนสร้างผู้ใช้ใหม่
    };

    loading(true);
    const result = !edit_uid ? await POST("admin/users", body) : await PUT("admin/users/" + edit_uid, body);
    loading(false);

    if (!result?.status) return;

    this.setState({ modal_form: false });
    await this.Get(edit_uid ? this.state.page : 1);
    alert("", "success", t("success"), edit_uid ? t("save_done") : t("add_user_done"));
  };

  /* ------------------------------------------------------ เปิด/ปิดใช้งาน */
  ToggleActive = async (item) => {
    // บัญชีผู้ดูแลระบบสูงสุดปิดใช้งานไม่ได้ (backend กันไว้อีกชั้น)
    if (isSuperUser(item)) return alert("", "warning", t("warning"), t("super_user_status_locked_desc"));

    /* บัญชีพาร์ตเนอร์เปิด-ปิดจากที่นี่ไม่ได้ : สถานะบัญชีถูกตั้งตามสถานะใบสมัคร
       (อนุมัติ = เปิด, ระงับ = ปิด) ถ้าสลับที่นี่ได้ จะได้พาร์ตเนอร์ที่ใบสมัครขึ้นว่า
       "ระงับการใช้งาน" แต่ยังล็อกอินเข้าระบบได้ */
    if (isPartnerUser(item)) return alert("", "warning", t("warning"), t("partner_status_managed_desc"));

    const next = !item.is_active;
    const detail = next ? t("enable_user_confirm") : t("disable_user_confirm");
    if (!(await alert("", "info", next ? t("enable_user") : t("disable_user"), `${detail}\n${item.full_name}`, t("confirm"), t("cancel")))) return;

    loading(true);
    const result = await PUT("admin/users/" + item.uid, { is_active: next });
    loading(false);

    if (!result?.status) return;

    await this.Get(this.state.page);
    alert("", "success", t("success"), next ? t("enable_user_done") : t("disable_user_done"));
  };

  /* --------------------------------------------------- ตั้งรหัสผ่านใหม่ */
  ResetPassword = async () => {
    const { password_form: form, password_item: item } = this.state;
    if (!item) return;

    if (!form.current_password) return alert("", "warning", t("warning"), t("verify_current_password"));
    if (!this.state.password_checked) return alert("", "warning", t("warning"), t("verify_check_current_password"));
    if ((form.password || "").length < 8) return alert("", "warning", t("warning"), t("verify_password_length"));
    if (form.password !== form.password_confirm) return alert("", "warning", t("warning"), t("verify_password_match"));

    if (!(await alert("", "info", t("reset_password"), `${t("reset_password_confirm")}\n${item.full_name}`, t("confirm"), t("cancel")))) return;

    loading(true);
    const result = await PUT("admin/users/" + item.uid + "/password", {
      current_password: form.current_password,
      password: form.password,
    });
    loading(false);

    if (!result?.status) return;

    // แจ้งผลให้เห็นก่อน แล้วค่อยปิดฟอร์มและโหลดรายการใหม่
    await alert("", "success", t("success"), t("reset_password_done"));

    this.setState({
      modal_password: false,
      password_checked: false,
      password_error: "",
      password_form: { ...EMPTY_PASSWORD_FORM },
    });
    await this.Get(this.state.page);
  };

  CopyEmail = (item) => {
    navigator.clipboard?.writeText(item.email);
    alert("", "success", t("success"), t("email_copied"));
  };

  /* ------------------------------------------------------------ ลบผู้ใช้ */
  Delete = async (item) => {
    if (!item) return;
    if (isPartnerUser(item)) return alert("", "warning", t("warning"), t("partner_delete_managed_desc"));
    if (!(await alert("", "warning", t("delete_item"), `${t("delete_user_desc")}\n${item.full_name}`, t("confirm"), t("cancel")))) return;

    loading(true);
    const result = await DELETE("admin/users/" + item.uid, null);
    loading(false);

    if (!result?.status) return;

    this.setState({ modal_form: false, modal_view: false });
    await this.Get(this.state.page);
    alert("", "success", t("success"), t("delete_done"));
  };

  /* ============================================== render : หัวตาราง (แท็บ) */
  /* แท็บอยู่บนหัวตารางในการ์ดเดียวกับผลลัพธ์ ไม่ใช่แถบใหญ่แยกใบ — ตัวกรองกับตาราง
     จะได้อยู่ติดกัน และแท็บยังเห็นอยู่ตอนแท็บนั้นไม่มีข้อมูล (กดสลับกลับได้)
     ใช้ prop-seg ชุดเดียวกับที่อื่นในระบบ แต่ย่อด้วย ppl-tabs ให้พอดีหัวตาราง */
  renderTableHead = () => {
    const { tab, counts } = this.state;

    /* padding ตั้งเป็น inline เพราะ .prop-card__head (16px 20px) มาทีหลัง utility
       ของ bootstrap คลาส py-2/px-3 จึงเอาไม่อยู่ */
    return (
      <div className="prop-card__head" style={{ padding: "10px 14px" }}>
        <div className="prop-seg ppl-tabs">
          {USER_TABS.map((item) => {
            const on = tab === item.key;
            const count = counts[item.key];

            return (
              <button
                key={item.key}
                type="button"
                aria-pressed={on}
                title={t(`user_tab_${item.key}_hint`)}
                className={`prop-seg__btn d-flex align-items-center gap-2 ${on ? "is-active" : ""}`}
                onClick={() => this.switchTab(item.key)}
              >
                <span className="icon text-12">{item.icon}</span>
                {t(item.label)}
                {count !== undefined && <span className="ppl-tabcount">{num(count)}</span>}
              </button>
            );
          })}
        </div>

        {/* คำอธิบายแท็บ — จอแคบซ่อนไว้ ยังอ่านได้จาก title ของปุ่ม */}
        <div className="ppl-sub d-none d-xl-block text-truncate" style={{ maxWidth: "52%" }}>
          {t(`user_tab_${tab}_hint`)}
        </div>
      </div>
    );
  };

  /* ==================================================== render : ตัวกรอง */
  renderFilter = () => {
    const { filter } = this.state;

    return (
      <div className="prop-card prop-in p-3 mb-3">
        <div className="d-flex flex-wrap align-items-center gap-2">
          <div className="position-relative flex-grow-1" style={{ minWidth: "240px", maxWidth: "420px" }}>
            <span className="icon prop-field-icon">{"\uf002"}</span>
            <input
              type="text"
              className="prop-field prop-field--icon"
              placeholder={t("search_users_placeholder")}
              value={filter.keyword}
              onChange={(e) => this.setFilter({ keyword: e.target.value })}
              onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
            />
          </div>
          <button type="button" className="prop-btn prop-btn--dark" onClick={() => this.Get(1)}>
            <span className="icon text-12">{"\uf002"}</span>
            {t("search")}
          </button>
          <button type="button" className="prop-btn prop-btn--ghost" onClick={this.clearFilters}>
            <span className="icon text-12">{"\uf00d"}</span>
            {t("clear_all")}
          </button>
        </div>
      </div>
    );
  };

  /* สั่งงานจากในเมนู : ปิดเมนูก่อนแล้วค่อยทำ ไม่งั้นเมนูจะค้างอยู่หลังโมดัลเด้ง */
  RowAction = (item, action) => this.setState({ menu_open: "" }, () => action(item));

  /* ปุ่มจัดการรายผู้ใช้ — รวมทุกคำสั่งไว้ในเมนู "..." เมนูเดียว ช่องจัดการจะได้ไม่กิน
     ความกว้างตาราง (แบบเดียวกับเมนูลูกค้า/ทรัพย์)

     index/total ใช้เลือกทิศทางที่เมนูกาง : แถวท้าย ๆ กางขึ้นบน จะได้ไม่ทะลุพ้นจอ
     (ต้องมีแถวอยู่เหนือพอสมควรด้วย ตารางสั้น ๆ จึงกางลงตามปกติ)

     บัญชีผู้ดูแลระบบสูงสุดลบไม่ได้ จึงไม่แสดงคำสั่งลบ
     บัญชีพาร์ตเนอร์ก็ไม่แสดงเหมือนกัน — ลบที่นี่แล้วใบสมัครในตาราง partners
     จะชี้ไปยัง user ที่ไม่มีอยู่ และเมนูพาร์ตเนอร์เองก็ห้ามลบใบสมัครที่ออกบัญชีไปแล้ว */
  renderActions = (item, index, total) => {
    const open = this.state.menu_open === item.uid;
    const up = index >= 3 && index >= total - 3;
    const deletable = !isSuperUser(item) && !isPartnerUser(item) && can("users.delete");

    /* ยกตัวยึดเมนูขึ้นเหนือฉากคลุม (1040) ทั้งก้อน เพื่อไม่ต้องหวังว่า z-index ของ
       .prop-pop จะไปเทียบกับฉากคลุมในชั้นเดียวกันเสมอ — และยังต่ำกว่า sweetalert2 (1060)
       กล่องแจ้งเตือนที่เด้งตามมาจึงยังทับเมนูได้ตามปกติ */
    return (
      <div className="d-flex justify-content-center">
        <div className="position-relative" style={open ? { zIndex: 1051 } : undefined}>
          <button
            type="button"
            className={`prop-iconbtn icon ${open ? "prop-iconbtn--dark" : ""}`}
            title={t("more_options")}
            aria-expanded={open}
            onClick={() => this.setState({ menu_open: open ? "" : item.uid })}
          >
            {"\uf141"}
          </button>

          {open && (
            <>
              {/* ฉากคลุมทั้งจอ — คลิกที่ไหนก็ปิดเมนู */}
              <div className="position-fixed" style={{ inset: 0, zIndex: 1040 }} onClick={() => this.setState({ menu_open: "" })} />
              <div className="prop-pop" style={up ? { top: "auto", bottom: "calc(100% + 8px)" } : undefined}>
                <button type="button" className="prop-pop__item" onClick={() => this.RowAction(item, this.OpenView)}>
                  <span className="icon">{"\uf06e"}</span>
                  {t("view_details")}
                </button>
                {can("users.update") && (
                  <button type="button" className="prop-pop__item" onClick={() => this.RowAction(item, this.OpenEdit)}>
                    <span className="icon">{"\uf044"}</span>
                    {t("edit")}
                  </button>
                )}
                {/* ตั้งรหัสผ่านใหม่ได้ทุกบัญชี รวมผู้ดูแลระบบสูงสุด เพราะต้องยืนยันด้วยรหัสผ่านเดิมอยู่แล้ว */}
                {can("users.update") && (
                  <button type="button" className="prop-pop__item" onClick={() => this.RowAction(item, this.OpenPassword)}>
                    <span className="icon">{"\uf084"}</span>
                    {t("reset_password")}
                  </button>
                )}
                {deletable && (
                  <>
                    <div className="prop-pop__sep" />
                    <button type="button" className="prop-pop__item is-danger" onClick={() => this.RowAction(item, this.Delete)}>
                      <span className="icon">{"\uf2ed"}</span>
                      {t("delete_user")}
                    </button>
                  </>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    );
  };

  /* รูปโปรไฟล์ — อัปโหลดไว้ก็ใช้รูปจริง ไม่มีจึงตกไปเป็นอักษรย่อบนพื้นสีประจำคน
     พื้นหลังยังใส่ไว้เสมอ เผื่อไฟล์รูปโหลดไม่ขึ้นจะได้ไม่เป็นกล่องขาวเปล่า */
  avatar = (item, size = "") => (
    <div
      className={`ppl-avatar ${size} ${item.is_active ? "" : "is-off"}`}
      style={{ background: avatarTone(item.email || item.full_name) }}
    >
      {item.picture ? (
        <img className="ppl-avatar__img" src={item.picture} alt={item.full_name || ""} />
      ) : (
        initials(item.full_name)
      )}
      <span className={`ppl-avatar__dot ${item.is_active ? "is-on" : ""}`} />
    </div>
  );

  /* ช่องเหรียญของบัญชีพาร์ตเนอร์
     ตัดสินจาก "มีกระเป๋าไหม" ไม่ใช่จากประเภทผู้ใช้ — กระเป๋าเกิดตอนอนุมัติใบสมัคร
     บัญชีที่ยังไม่มีจึงขึ้นขีดกลาง ไม่ใช่เลข 0 ซึ่งแปลว่ามีกระเป๋าแต่ไม่มีเหรียญ

     ปรับยอดเหรียญทำที่นี่ไม่ได้ เหมือนสถานะและการลบของบัญชีพาร์ตเนอร์ที่ล็อกไว้
     ทั้งหมด — เหรียญเดินตามรายการของระบบ ไม่ใช่ตัวเลขที่พิมพ์แก้จากหน้ารายชื่อ */
  renderWallet = (wallet) => {
    if (!wallet) return <span className="wlt-cell__empty">-</span>;

    const frozen = wallet.status === "frozen";

    return (
      <div>
        <div className={`wlt-cell${frozen ? " wlt-cell--frozen" : ""}`}>
          <span className="wlt-cell__coin icon">{COIN_ICON}</span>
          <span className="wlt-cell__value">
            {coin(wallet.balance)}
            <span className="wlt-cell__unit">{t("wallet_unit_coin")}</span>
          </span>
        </div>
        {/* กระเป๋าถูกแช่ตอนพาร์ตเนอร์ถูกระงับ — ยอดยังอยู่ครบ แค่ใช้ออกไม่ได้ */}
        {frozen && <div className="wlt-cell__note">{t("wallet_status_frozen")}</div>}
      </div>
    );
  };

  /* ==================================================== render : ตารางผู้ใช้ */
  /* ไม่ล็อกความกว้างทั้งตารางและรายคอลัมน์ — ปล่อยให้เบราว์เซอร์จัดตามเนื้อหาจริง
     (ชื่อยาว/สั้น อีเมลยาว/สั้น) คอลัมน์จะได้ไม่เหลือที่ว่างหรือบีบจนอ่านไม่ออก
     ยังคง table-responsive ไว้เผื่อจอแคบมากจนตารางล้น */
  renderTable = () => {
    const { data, menu_open, tab } = this.state;
    const isPartnerTab = tab === "partner";

    /* table-responsive = overflow-x: auto ซึ่งเบราว์เซอร์บังคับให้ overflow-y เป็น auto
       ตามไปด้วย กล่องนี้จึงตัดขอบทุกอย่างที่ล้นออกนอกตาราง รวมถึงเมนู "..." ที่กางอยู่
       (ยิ่งมีผู้ใช้ไม่กี่แถว ตารางยิ่งเตี้ย เมนูโดนตัดหายทั้งอัน)
       ตอนมีเมนูกางจึงเปิด overflow ทิ้งไว้ก่อน — มุมล่างของตารางไม่ได้พึ่ง overflow แล้ว
       เพราะย้ายไปโค้งที่แถวสุดท้ายใน people.css แทน */
    return (
      <div
        className="table-responsive"
        style={{ borderRadius: "0 0 18px 18px", overflow: menu_open ? "visible" : undefined }}
      >
        <table className={`ppl-table ${menu_open ? "is-menu-open" : ""}`}>
          <thead>
            <tr>
              <th>{t("user_col")}</th>
              <th>{t("contact")}</th>
              <th>{t("user_type")}</th>
              <th>{t("role")}</th>
              <th>{t("last_login")}</th>
              <th className="text-center">{t("status")}</th>
              {/* เหรียญขึ้นเฉพาะแท็บพาร์ตเนอร์ — ทีมงานภายในไม่มีกระเป๋าสักคน
                  โชว์ไว้ทั้งแท็บก็ได้คอลัมน์ที่มีแต่ขีดกลางทุกแถว */}
              {isPartnerTab && <th>{t("wallet_coin")}</th>}
              <th className="text-center">{t("actions")}</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => {
              const type = typeMeta(item.user_type);

              return (
                <tr
                  key={item.uid}
                  className={`${item.is_active ? "" : "is-off"} ${menu_open === item.uid ? "is-menu-open" : ""}`}
                >
                  {/* ผู้ใช้ */}
                  <td>
                    <div className="d-flex align-items-center gap-3">
                      {this.avatar(item)}
                      <div className="min-w-0">
                        <div className="ppl-name text-truncate">{item.full_name}</div>
                        <div className="ppl-sub">
                          {item.user_code}
                          {item.nickname ? ` · ${item.nickname}` : ""}
                        </div>
                      </div>
                    </div>
                  </td>

                  {/* ติดต่อ */}
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <span className="icon text-secondary text-12">{""}</span>
                      <span className="text-truncate">{item.email}</span>
                      <button type="button" className="prop-link icon text-12" title={t("copy_email")} onClick={() => this.CopyEmail(item)}>
                        {""}
                      </button>
                    </div>
                    <div className="ppl-sub d-flex align-items-center gap-2 mt-1">
                      <span className="icon text-12">{""}</span>
                      {fmtPhone(item.phone)}
                    </div>
                  </td>

                  {/* ประเภท + ทีม */}
                  <td>
                    <span className="ppl-type">
                      <span className="ppl-type__dot" style={{ background: type.tone }} />
                      {t(type.label)}
                    </span>
                    <div className="ppl-sub mt-1 ms-3">{t(teamMeta(item.team)?.label || "-")}</div>
                  </td>

                  {/* บทบาท */}
                  <td>
                    <span className="ppl-pill ppl-pill--role">
                      <span className="icon text-10">{""}</span>
                      {item.role_name || "-"}
                    </span>
                  </td>

                  {/* เข้าใช้ล่าสุด */}
                  <td>
                    <div className={item.last_login_at ? "" : "text-secondary"}>{timeAgo(item.last_login_at)}</div>
                    {!!item.last_login_at && (
                      <div className="ppl-sub">{format_date(item.last_login_at, "dd mmm yyyy hh:mm", locale())}</div>
                    )}
                  </td>

                  {/* สถานะ */}
                  <td className="text-center">
                    <label
                      className="ppl-switch"
                      title={
                        isSuperUser(item)
                          ? t("super_user_status_locked_desc")
                          : isPartnerUser(item)
                          ? t("partner_status_managed_desc")
                          : item.is_active
                          ? t("disable_user")
                          : t("enable_user")
                      }
                    >
                      <input
                        type="checkbox"
                        checked={item.is_active}
                        disabled={isSuperUser(item) || isPartnerUser(item)}
                        onChange={() => this.ToggleActive(item)}
                      />
                      <span className="ppl-switch__track" />
                    </label>
                    <div className={`ppl-sub mt-1 fw-bold ${item.is_active ? "text-success" : ""}`}>
                      {item.is_active ? t("active") : t("inactive")}
                    </div>
                  </td>

                  {/* กระเป๋าเหรียญ — เปิดให้ตอนอนุมัติใบสมัคร ยังไม่มีคือขีดกลาง */}
                  {isPartnerTab && <td>{this.renderWallet(item.wallet)}</td>}

                  {/* จัดการ */}
                  <td>{this.renderActions(item, index, data.length)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  /* ===================================================== render : ผลลัพธ์ */
  renderResults = () => {
    const { data, count, page, tab, applied } = this.state;

    /* ไม่มีคำค้นแล้วยังว่าง = แท็บนั้นยังไม่มีใครเลย ไม่ใช่ "หาไม่เจอ" — ปุ่มล้าง
       ตัวกรองจึงไม่ช่วยอะไร บอกที่มาของบัญชีในแท็บนั้นแทน */
    const searching = !!(applied.keyword || "").trim();
    const from = (page - 1) * PAGE_SIZE + 1;
    const to = Math.min(page * PAGE_SIZE, count);

    return (
      <>
        {/* หัวตาราง (แท็บ) อยู่ในการ์ดใบเดียวกับผลลัพธ์เสมอ ตอนไม่มีข้อมูลจะได้ยัง
            กดสลับกลับไปอีกแท็บได้ */}
        <div className="prop-card prop-in">
          {this.renderTableHead()}

          {data.length ? (
            this.renderTable()
          ) : (
            <div className="prop-empty">
              <div className="prop-empty__icon icon">{"\uf0c0"}</div>
              <div className="fw-bold text-dark mb-1">{searching ? t("no_users_found") : t(`user_tab_${tab}_empty`)}</div>
              <div className="text-12">{searching ? t("try_adjust_filters") : t(`user_tab_${tab}_empty_desc`)}</div>
              {searching && (
                <button type="button" className="prop-btn prop-btn--ghost prop-btn--sm mt-3" onClick={this.clearFilters}>
                  <span className="icon text-12">{"\uf01e"}</span>
                  {t("clear_all")}
                </button>
              )}
            </div>
          )}
        </div>

        {!!data.length && (
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mt-4 text-secondary text-12">
            <div>
              {t("showing")} {from}-{to} {t("of")} {num(count)} {t("users_count")}
            </div>
            <Pagination
              className="mb-0"
              page={page}
              count={Math.ceil(count / PAGE_SIZE) || 1}
              showFirstButton={false}
              showLastButton={false}
              onChange={(_, next) => {
                this.Get(next, this.state.applied);
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            />
          </div>
        )}
      </>
    );
  };

  /* ============================================= render : ฟอร์ม เพิ่ม/แก้ไข */
  renderFormModal = () => {
    const { modal_form, edit_uid, edit_item, form, roles, show_password } = this.state;
    const emailError = !!form.email.trim() && !isValidEmail(form.email);
    const role = roleMeta(form.role_uid, roles);
    // แก้ไขบัญชีผู้ดูแลระบบสูงสุด : ประเภทผู้ใช้และบทบาทล็อกไว้ ลบก็ไม่ได้
    const locked = isSuperUser(edit_item);
    /* บัญชีพาร์ตเนอร์ : แก้ข้อมูลติดต่อได้ แต่ประเภทผู้ใช้ สถานะ และการลบเป็นของ
       เมนูพาร์ตเนอร์ เพราะผูกกับใบสมัคร — เหตุผลเดียวกับที่กันไว้ในตาราง */
    const managed = isPartnerUser(edit_item);
    const preview = {
      full_name: form.full_name || t("new_user_preview"),
      email: form.email,
      picture: form.picture,
      is_active: form.is_active,
    };

    const section = (icon, title, desc, children) => (
      <div className="ppl-section">
        <div className="ppl-section__title mb-3">
          <span className="icon">{icon}</span>
          {title}
        </div>
        {children}
      </div>
    );

    return (
        <Modal size="lg" show={modal_form} onHide={() => this.setState({ modal_form: false })} centered contentClassName="border-0 rounded-4 overflow-visible shadow-lg">
            <Modal.Header className="border-bottom border-light px-4 py-3 bg-white">
                <div>
                    <h5 className="fw-bold mb-0 text-dark">{edit_uid ? t("edit_user") : t("add_new_user")}</h5>
                    <div className="text-secondary text-12">{edit_uid ? t("edit_user_desc") : t("add_new_user_desc")}</div>
                </div>
            </Modal.Header>

            <Modal.Body className="p-4 bg-white">
                {/* ตัวอย่างบัตรผู้ใช้ — เห็นผลทันทีระหว่างกรอก */}
                <div className="d-flex align-items-center gap-3 p-3 mb-4 rounded-4" style={{ background: "linear-gradient(102deg,#eaf9d2,#f8fcef)", border: "1px solid #d5efab" }}>
                    {this.avatar(preview, "ppl-avatar--lg")}
                    <div className="min-w-0">
                        <div className="fw-bold text-dark text-16 text-truncate">{preview.full_name}</div>
                        <div className="text-secondary text-12 text-truncate">{form.email || t("email")}</div>
                        <div className="d-flex flex-wrap gap-2 mt-2">
                            {!!form.user_type && <span className="ppl-pill ppl-pill--ghost">{t(typeMeta(form.user_type).label)}</span>}
                            <span className={`ppl-pill ${form.is_active ? "ppl-pill--on" : "ppl-pill--off"}`}>
                                <span className="ppl-pill__dot" />
                                {form.is_active ? t("active") : t("inactive")}
                            </span>
                        </div>
                    </div>
                </div>

                {section(
                    "",
                    t("basic_information"),
                    t("basic_info_desc"),
                    <div className="row g-3">
                        {/* รูปโปรไฟล์ — วางไว้ก่อนชื่อ เพราะเป็นสิ่งแรกที่เห็นทั้งในตาราง
                            หน้ารายละเอียด และท้ายการ์ดทรัพย์บนเว็บฝั่งลูกค้า */}
                        <div className="col-12">
                            <label className="prop-label">{t("profile_picture")}</label>
                            <div className="ppl-upload">
                                {this.avatar(preview, "ppl-avatar--lg")}

                                <div className="flex-grow-1 min-w-0">
                                    <div className="d-flex flex-wrap align-items-center gap-2">
                                        <label className="prop-btn prop-btn--ghost prop-btn--sm mb-0">
                                            <span className="icon text-12">{""}</span>
                                            {form.picture ? t("picture_change") : t("picture_upload")}
                                            <input type="file" accept={PICTURE_ACCEPT} className="d-none" onChange={this.PickPicture} />
                                        </label>
                                        {!!form.picture && (
                                            <button type="button" className="prop-btn prop-btn--ghost prop-btn--sm" onClick={this.ClearPicture}>
                                                <span className="icon text-12">{""}</span>
                                                {t("picture_remove")}
                                            </button>
                                        )}
                                    </div>
                                    <div className="text-secondary text-10 mt-2">
                                        {t("picture_hint").replace("{size}", PICTURE_SIZE_HINT)}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <label className="prop-label">
                                {t("full_name")} <span className="text-danger">*</span>
                            </label>
                            <input type="text" className="prop-field" placeholder={t("full_name_placeholder")} value={form.full_name} onChange={(e) => this.setForm({ full_name: e.target.value })} />
                        </div>
                        <div className="col-md-6">
                            <label className="prop-label">{t("nickname")}</label>
                            <input type="text" className="prop-field" placeholder={t("nickname_placeholder")} value={form.nickname} onChange={(e) => this.setForm({ nickname: e.target.value })} />
                        </div>
                        <div className="col-md-6">
                            <label className="prop-label">
                                {t("user_code")} <span className="text-danger">*</span>
                            </label>
                            <input type="text" className="prop-field" placeholder="SL-2026080001" maxLength={20} value={form.user_code} onChange={(e) => this.setForm({ user_code: e.target.value })} />
                        </div>
                        <div className="col-md-6">
                            <label className="prop-label">{t("phone")}</label>
                            <input
                                type="text"
                                className="prop-field"
                                placeholder="08X-XXX-XXXX"
                                maxLength={10}
                                value={form.phone}
                                onChange={(e) => float(e.target.value) && this.setForm({ phone: e.target.value })}
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="prop-label">
                                {t("email")} <span className="text-danger">*</span>
                            </label>
                            <input
                                type="email"
                                className="prop-field"
                                style={emailError ? { borderColor: "#ef4444" } : undefined}
                                placeholder="name@safespacelifeliving.com"
                                value={form.email}
                                onChange={(e) => this.setForm({ email: e.target.value })}
                            />
                            {emailError && <div className="text-danger text-12 mt-1">{t("invalid_email_address")}</div>}
                        </div>
                        {/* LINE ID — เว็บฝั่งลูกค้าเอาไปทำปุ่ม "เพิ่มเพื่อน" ท้ายการ์ดทรัพย์
                            รับได้ทั้งบัญชีทางการ (@munera) ไอดีส่วนตัว และลิงก์เต็ม
                            ตัวแปลงเป็นลิงก์อยู่ที่ lineAddUrl ใน components/people_option.js */}
                        <div className="col-md-6">
                            <label className="prop-label">{t("line_id")}</label>
                            <input
                                type="text"
                                className="prop-field"
                                placeholder="@safespacelifeliving"
                                maxLength={200}
                                value={form.line_id}
                                onChange={(e) => this.setForm({ line_id: e.target.value })}
                            />
                            <div className="ppl-sub mt-1">{t("line_id_hint")}</div>
                        </div>
                    </div>
                )}

                {section(
                    "",
                    t("role_assignment"),
                    t("role_assignment_desc"),
                    <div className="row g-3">
                        {(locked || managed) && (
                            <div className="col-12">
                                <div className="ppl-note ppl-note--lock">
                                    <span className="icon">{"\uf023"}</span>
                                    <div>{locked ? t("super_user_locked_desc") : t("partner_account_locked_desc")}</div>
                                </div>
                            </div>
                        )}
                        <div className="col-md-4">
                            <label className="prop-label">
                                {t("user_type")} <span className="text-danger">*</span>
                            </label>
                            <Select
                                className="prop-field prop-select"
                                default={false}
                                disabled={locked || managed}
                                placeholder={t("select_user_type")}
                                value={form.user_type}
                                /* บัญชีพาร์ตเนอร์ตั้งจากที่นี่ไม่ได้ — ต้องเกิดจากการอนุมัติใบสมัคร
                                   ในเมนูพาร์ตเนอร์เท่านั้น (backend ปฏิเสธไว้อีกชั้น) จึงไม่ให้เลือก
                                   แต่ตอนแก้บัญชีพาร์ตเนอร์ต้องมีตัวเลือกนี้อยู่ในรายการ ไม่งั้นช่องจะ
                                   โชว์ว่างทั้งที่มีค่าอยู่ — ใส่ให้ครบแล้วปิดไม่ให้แก้แทน */
                                options={(managed ? USER_TYPES : SELECTABLE_USER_TYPES).map((type) => ({ value: type.value, label: t(type.label) }))}
                                onChange={(value) => this.setForm({ user_type: value })}
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="prop-label">
                                {t("role")} <span className="text-danger">*</span>
                            </label>
                            <Select
                                className="prop-field prop-select"
                                default={false}
                                disabled={locked || managed}
                                placeholder={t("select_role")}
                                value={form.role_uid}
                                options={roles.map((item) => ({ value: item.uid, label: item.name }))}
                                onChange={(value) => this.setForm({ role_uid: value })}
                            />
                        </div>
                        {/* ทีม/สาขา กับ เป้ายอดขาย เป็นเรื่องของทีมงานภายใน — พาร์ตเนอร์เป็นนายหน้า
                            ภายนอกที่ไม่ได้สังกัดสาขาและไม่ได้ถูกตั้งเป้าไว้ในระบบ */}
                        {!managed && (
                            <>
                                <div className="col-md-4">
                                    <label className="prop-label">
                                        {t("team")} <span className="text-danger">*</span>
                                    </label>
                                    <Select
                                        className="prop-field prop-select"
                                        default={false}
                                        placeholder={t("select_team")}
                                        value={form.team}
                                        options={TEAMS.map((team) => ({ value: team.value, label: t(team.label) }))}
                                        onChange={(value) => this.setForm({ team: value })}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="prop-label">{t("sales_target")}</label>
                                    <input
                                        type="text"
                                        className="prop-field"
                                        inputMode="numeric"
                                        placeholder={t("sales_target_placeholder")}
                                        value={form.sales_target}
                                        onChange={(e) => float(e.target.value) && this.setForm({ sales_target: e.target.value })}
                                    />
                                    <div className="text-secondary text-12 mt-1">{t("sales_target_hint")}</div>
                                </div>
                            </>
                        )}
                    </div>
                )}

                {/* เปลี่ยนรหัสผ่านของผู้ใช้เดิมต้องใช้ปุ่มกุญแจในตาราง — ที่นี่ตั้งได้เฉพาะตอนสร้างใหม่ */}
                {!edit_uid &&
                    section(
                        "",
                        t("account_security"),
                        t("account_security_desc"),
                        <div className="row g-3">
                            <div className="col-md-6">
                                <label className="prop-label">
                                    {edit_uid ? t("new_password") : t("password")} {!edit_uid && <span className="text-danger">*</span>}
                                </label>
                                <div className="position-relative">
                                    <input
                                        type={show_password ? "text" : "password"}
                                        className="prop-field"
                                        placeholder={t("password_placeholder")}
                                        value={form.password}
                                        disabled={locked}
                                        onChange={(e) => this.setForm({ password: e.target.value })}
                                    />
                                    <button
                                        type="button"
                                        className="prop-link icon position-absolute"
                                        style={{ right: "12px", top: "13px" }}
                                        title={show_password ? t("hide_password") : t("show_password")}
                                        disabled={locked}
                                        onClick={() => this.setState({ show_password: !show_password })}
                                    >
                                        {show_password ? "" : ""}
                                    </button>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="prop-label">
                                    {t("confirm_password")} {!edit_uid && <span className="text-danger">*</span>}
                                </label>
                                <input
                                    type={show_password ? "text" : "password"}
                                    className="prop-field"
                                    placeholder={t("confirm_password")}
                                    value={form.password_confirm}
                                    disabled={locked}
                                    onChange={(e) => this.setForm({ password_confirm: e.target.value })}
                                />
                                {!!form.password_confirm && form.password !== form.password_confirm && <div className="text-danger text-12 mt-1">{t("verify_password_match")}</div>}
                            </div>
                        </div>
                    )}

                {section(
                    "",
                    t("status"),
                    t("status_desc"),
                    <div className="d-flex align-items-center gap-3">
                        {/* บัญชีผู้ดูแลระบบสูงสุดกับบัญชีพาร์ตเนอร์ปิดใช้งานที่นี่ไม่ได้ ล็อกสวิตช์ไว้เหมือนในตาราง */}
                        <label className="ppl-switch" title={locked ? t("super_user_status_locked_desc") : managed ? t("partner_status_managed_desc") : ""}>
                            <input type="checkbox" checked={form.is_active} disabled={locked || managed} onChange={(e) => this.setForm({ is_active: e.target.checked })} />
                            <span className="ppl-switch__track" />
                        </label>
                        <div>
                            <div className="fw-bold text-dark text-14">{form.is_active ? t("active") : t("inactive")}</div>
                            {locked && <div className="text-secondary text-12">{t("super_user_status_locked_desc")}</div>}
                            {managed && <div className="text-secondary text-12">{t("partner_status_managed_desc")}</div>}
                        </div>
                    </div>
                )}
            </Modal.Body>

            <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-between gap-2">
                <div>
                    {!!edit_uid && !locked && !managed && can("users.delete") && (
                        <button type="button" className="prop-btn prop-btn--ghost" style={{ borderColor: "#fecaca", color: "#b91c1c" }} onClick={() => this.Delete(edit_item)}>
                            <span className="icon text-12">{""}</span>
                            {t("delete_data")}
                        </button>
                    )}
                </div>
                <div className="d-flex gap-2">
                    <button type="button" className="prop-btn prop-btn--ghost" onClick={() => this.setState({ modal_form: false })}>
                        {t("cancel")}
                    </button>
                    <button type="button" className="prop-btn" onClick={this.Save}>
                        <span className="icon text-12">{"\uf0c7"}</span>
                        {t("save")}
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    );
  };

  /* ========================================== render : กล่องดูรายละเอียด */
  renderViewModal = () => {
    const { modal_view, view_item: item } = this.state;
    if (!item) return null;

    const type = typeMeta(item.user_type);

    const kv = (label, value) => (
      <div className="ppl-kv">
        <span className="ppl-kv__label">{label}</span>
        <span className="ppl-kv__value">{value}</span>
      </div>
    );

    return (
      <Modal
        size="md"
        show={modal_view}
        onHide={() => this.setState({ modal_view: false })}
        centered
        contentClassName="border-0 rounded-4 overflow-hidden shadow-lg"
      >
        <Modal.Body className="p-0 bg-white">
          {/* หัวกล่อง — โทนเข้มตัดกับเนื้อหาด้านล่าง */}
          <div className="p-4 text-white" style={{ background: "linear-gradient(150deg,#22351f 0%,#142016 62%)" }}>
            <div className="d-flex align-items-center gap-3">
              {this.avatar(item, "ppl-avatar--xl")}
              <div className="min-w-0">
                <h5 className="fw-bold mb-1 text-truncate">{item.full_name}</h5>
                <div className="text-12 mb-2" style={{ color: "rgba(255,255,255,0.66)" }}>
                  {item.user_code}
                  {item.nickname ? ` · ${item.nickname}` : ""}
                </div>
                <div className="d-flex flex-wrap gap-2">
                  <span className="ppl-pill ppl-pill--role">{t(type.label)}</span>
                  <span className={`ppl-pill ${item.is_active ? "ppl-pill--on" : "ppl-pill--off"}`}>
                    <span className="ppl-pill__dot" />
                    {item.is_active ? t("active") : t("inactive")}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="p-4">
            {kv(t("email"), item.email)}
            {kv(t("phone"), fmtPhone(item.phone))}
            {kv(t("line_id"), item.line_id || "-")}
            {/* พาร์ตเนอร์ไม่ได้สังกัดทีม/สาขา ช่องนี้จึงเป็นขีดกลางเสมอ — ตัดออกไปเลย */}
            {!isPartnerUser(item) && kv(t("team"), t(teamMeta(item.team)?.label || "-"))}
            {kv(t("role"), item.role_name || "-")}
            {/* กระเป๋าเหรียญมีเฉพาะบัญชีพาร์ตเนอร์ — บัญชีอื่นไม่ต้องมีช่องนี้ให้อ่านผ่าน */}
            {isPartnerUser(item) && kv(t("wallet_coin"), this.renderWallet(item.wallet))}
            {kv(t("last_login"), item.last_login_at ? format_date(item.last_login_at, "dd mmm yyyy hh:mm", locale()) : t("time_never"))}
            {kv(t("created_at"), format_date(item.created_at, "dd mmm yyyy", locale()))}
          </div>
        </Modal.Body>

        <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
          <button type="button" className="prop-btn prop-btn--ghost" onClick={() => this.setState({ modal_view: false })}>
            {t("close")}
          </button>
          {can("users.update") && (
            <button type="button" className="prop-btn" onClick={() => this.OpenEdit(item)}>
              <span className="icon text-12">{""}</span>
              {t("edit_user")}
            </button>
          )}
        </Modal.Footer>
      </Modal>
    );
  };

  /* ====================================== render : ฟอร์มตั้งรหัสผ่านใหม่ */
  renderPasswordModal = () => {
    const { modal_password, password_item: item, password_form: form, show_password, password_checked, password_error } = this.state;
    if (!item) return null;

    const mismatch = !!form.password_confirm && form.password !== form.password_confirm;

    // ช่องรหัสผ่านใหม่เปิดใช้งานหลังตรวจรหัสผ่านเดิมผ่านแล้วเท่านั้น
    const field = (label, key, placeholder) => (
      <div className="col-12">
        <label className="prop-label">
          {label} <span className="text-danger">*</span>
        </label>
        <input
          type={show_password ? "text" : "password"}
          className="prop-field"
          placeholder={placeholder}
          value={form[key]}
          disabled={!password_checked}
          onChange={(e) => this.setPasswordForm({ [key]: e.target.value })}
        />
      </div>
    );

    return (
      <Modal
        size="md"
        show={modal_password}
        onHide={() => this.setState({ modal_password: false })}
        centered
        contentClassName="border-0 rounded-4 overflow-visible shadow-lg"
      >
        <Modal.Header className="border-bottom border-light px-4 py-3 bg-white">
          <div>
            <h5 className="fw-bold mb-0 text-dark">
              <span className="icon me-2">{"\uf084"}</span>
              {t("reset_password")}
            </h5>
            <div className="text-secondary text-12">{t("reset_password_desc")}</div>
          </div>
        </Modal.Header>

        <Modal.Body className="p-4 bg-white">
          {/* บอกให้ชัดว่ากำลังตั้งรหัสผ่านใหม่ให้ใคร กันกดผิดแถว */}
          <div className="d-flex align-items-center gap-3 p-3 mb-4 rounded-4" style={{ background: "#f6f8f3", border: "1px solid #e4ebdb" }}>
            {this.avatar(item)}
            <div className="min-w-0">
              <div className="fw-bold text-dark text-truncate">{item.full_name}</div>
              <div className="text-secondary text-12 text-truncate">{item.email}</div>
            </div>
          </div>

          <div className="row g-3">
            {/* ขั้นที่ 1 : ตรวจรหัสผ่านเดิมก่อน ปุ่มตรวจสอบอยู่ติดท้ายช่อง */}
            <div className="col-12">
              <label className="prop-label">
                {t("current_password")} <span className="text-danger">*</span>
              </label>
              <div className="d-flex gap-2">
                <input
                  type={show_password ? "text" : "password"}
                  className="prop-field flex-grow-1"
                  style={password_error ? { borderColor: "#ef4444" } : undefined}
                  placeholder={t("current_password_placeholder")}
                  value={form.current_password}
                  disabled={password_checked}
                  onChange={(e) => this.setCurrentPassword(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && !password_checked && this.CheckCurrentPassword()}
                />
                {password_checked ? (
                  <button
                    type="button"
                    className="prop-btn prop-btn--ghost flex-shrink-0"
                    title={t("change_current_password")}
                    onClick={() => this.setCurrentPassword("")}
                  >
                    <span className="icon text-12">{"\uf304"}</span>
                    {t("edit")}
                  </button>
                ) : (
                  <button type="button" className="prop-btn prop-btn--dark flex-shrink-0" onClick={this.CheckCurrentPassword}>
                    <span className="icon text-12">{"\uf00c"}</span>
                    {t("check")}
                  </button>
                )}
              </div>
              {!!password_error && <div className="text-danger text-12 mt-1">{password_error}</div>}
              {password_checked && (
                <div className="text-12 mt-1 fw-bold text-success">
                  <span className="icon text-10 me-1">{"\uf00c"}</span>
                  {t("current_password_verified")}
                </div>
              )}
            </div>

            {/* ขั้นที่ 2 : ตั้งรหัสผ่านใหม่ — ล็อกไว้จนกว่าจะตรวจผ่าน */}
            {field(t("new_password"), "password", t("password_placeholder"))}
            {field(t("confirm_password"), "password_confirm", t("confirm_password"))}
            {mismatch && (
              <div className="col-12">
                <div className="text-danger text-12">{t("verify_password_match")}</div>
              </div>
            )}
            <div className="col-12">
              <label className="d-flex align-items-center gap-2 text-secondary text-12">
                <input type="checkbox" checked={show_password} onChange={(e) => this.setState({ show_password: e.target.checked })} />
                {t("show_password")}
              </label>
            </div>
            <div className="col-12">
              <div className="ppl-note ppl-note--lock">
                <span className="icon">{"\uf023"}</span>
                <div>
                  <div>{t("reset_password_logout_note")}</div>
                  <div className="mt-1">{t("reset_password_unlink_note")}</div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
          <button type="button" className="prop-btn prop-btn--ghost" onClick={() => this.setState({ modal_password: false })}>
            {t("cancel")}
          </button>
          <button type="button" className="prop-btn" disabled={!password_checked} onClick={this.ResetPassword}>
            <span className="icon text-12">{"\uf0c7"}</span>
            {t("save")}
          </button>
        </Modal.Footer>
      </Modal>
    );
  };

  render() {
    const { tab } = this.state;
    // แท็บพาร์ตเนอร์สร้างบัญชีจากที่นี่ไม่ได้ — ชี้ไปเมนูพาร์ตเนอร์แทน (บัญชีเกิดตอนอนุมัติใบสมัคร)
    const partnerTab = tab === "partner";

    return (
      <div className="w-100 min-vh-100 prop-page">
        <NavbarAdmin />
        <div className="body p-4">
          {/* หัวข้อหน้า */}
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3 prop-in">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("user_management")}</h3>
              <div className="text-secondary text-14">{t("manage_users_desc")}</div>
            </div>
            <div className="d-flex gap-2">
              {partnerTab
                ? can("partners.read") && (
                    <button type="button" className="prop-btn" onClick={() => this.props.router.navigate("/ad/partners")}>
                      <span className="icon text-14">{"\uf2b5"}</span>
                      {t("open_partner_menu")}
                    </button>
                  )
                : can("users.create") && (
                    <button type="button" className="prop-btn" onClick={this.OpenCreate}>
                      <span className="icon text-14">{"\uf234"}</span>
                      {t("add_user")}
                    </button>
                  )}
            </div>
          </div>

          {this.renderFilter()}
          {this.renderResults()}
        </div>

        {this.renderFormModal()}
        {this.renderViewModal()}
        {this.renderPasswordModal()}
      </div>
    );
  }
}

export default withRouter(UserManagement);
